import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { addPageAction } from '../newrelic';
import Sidebar from './Sidebar';

// Walks up from the clicked node to the nearest interactive ancestor so
// labels for synthetic clicks (e.g. clicking the icon inside a button) are
// still attributed to the button. Stops at the document root.
function findInteractive(start) {
  let node = start;
  while (node && node !== document.body) {
    if (node.nodeType === 1) {
      const tag = node.tagName;
      if (tag === 'BUTTON' || tag === 'A' || tag === 'INPUT' || tag === 'SELECT' ||
          node.getAttribute('role') === 'button' || node.hasAttribute('data-track')) {
        return node;
      }
    }
    node = node.parentNode;
  }
  return start;
}

export default function Layout() {
  const location = useLocation();

  // Capture-phase listener so we see clicks even when the target stops
  // propagation. addPageAction is a no-op when the NR agent isn't initialized,
  // so this is safe in local dev / Okta-disabled deploys.
  useEffect(() => {
    const onClick = (event) => {
      const target = findInteractive(event.target);
      addPageAction('ui.click', {
        tag: target.tagName?.toLowerCase() ?? 'unknown',
        id: target.id || undefined,
        name: target.getAttribute?.('name') || undefined,
        text: (target.innerText || target.value || '').trim().slice(0, 80),
        href: target.getAttribute?.('href') || undefined,
        track: target.getAttribute?.('data-track') || undefined,
        route: location.pathname,
      });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, [location.pathname]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          marginLeft: 240,
          padding: '1.5rem 2rem',
          maxWidth: 'calc(100vw - 240px)',
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
